import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-html-block',
  styleUrls: ['./html-block-form-field.component.scss'],
  templateUrl: './html-block-form-field.component.html',
  standalone: false,
})
export class HtmlBlockFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  htmlData: string;

  constructor(private sanitized: DomSanitizer) {
    super();
  }

  ngOnDestroy() {}

  ngOnInit(): void {
    this.htmlData = this.data ? this.sanitized.bypassSecurityTrustHtml(this.data) : this.data;
  }
}
